// extracted by mini-css-extract-plugin
export default {"text_tip":"checkPassword_text_tip__1vAhv"};